export const styles = {
    dropdown: {
      width: "10%",
      margin: "0.5%",
    },
    selection: {
      maxHeight: 148,
      overflowY: "scroll",
    },
    linkedName: {
      cursor: "pointer",
      fontWeight: "bold",
    },
    searchBox: {
      width: "20%",
      marginLeft: "auto",
      marginRight: "1em",
    },
    searchArea: {
      width: "100%",
      display: "flex",
      justifyContent: "flex-end",
    },
    tableToolBar: {
      marginLeft: "2em",
      marginBottom: "1em",
    },
    importIcon: {
      marginLeft: "1em",
      marginTop: "0.7em",
    },
    rightActionButton: {
      marginLeft: "1em",
    },
    title: {
      fontWeight: "bold",
      marginBottom: "0.5em",
      paddingTop: "1em",
    },
    firstButton: {
      height: "40px",
      marginTop: "0.6em",
      marginLeft: "0.6em",
    },
    actionButton: {
      height: "40px",
      marginTop: "0.6em",
      marginLeft: "1em",
    },
    table: {
      fontSize: 16,
      height: "65vh",
    },
  };
  
  export const applicatorDialogStyles = {
    dialogTitle: {
      textAlign: "center",
      marginTop: "1%",
    },
  };
  
  export const importDialogStyles = {
    cellCeneter: {
      textAlign: "center",
    },
    dialogTitle: {
      textAlign: "center",
      marginTop: "1%",
    },
    dialogContent: {
      padding: "2em",
    },
    content: {
      display: "flex",
      justifyContent: "space-around",
      alignItems: "center",
      height: "90%",
      overflowX: "hidden",
    },
    slide1: {
      content: {
        width: "90%",
      },
      title: {
        textAlign: "center",
        fontWeight: "bold",
      },
    },
    slide2: {
      content: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "1rem",
        border: "2px dashed #aaaaaa",
        padding: "8rem",
        borderRadius: "8px",
        marginTop: "2em",
      },
      title: {
        textAlign: "center",
      },
      button: {
        alignSelf: "center",
      },
      image: {
        width: "50px",
        height: "50px",
      },
      actionButton: {
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
      },
    },
    slide3: {
      content: {
        width: "90%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      },
      title: {
        textAlign: "center",
        fontWeight: "bold",
      },
      loadingIcon: {
        textAlign: "center",
        marginTop: "2em",
      },
      errorText: {
        textAlign: "center",
        fontWeight: "bold",
        marginBottom: "2em",
      },
      errorIcon: {
        fontSize: 200,
      },
    },
    slide4: {
      content: {
        width: "90%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      },
      title: {
        textAlign: "center",
        fontWeight: "bold",
      },
      response: {
        textAlign: "center",
      },
    },
  };
  export const updateStyles = {
    title: {
      marginBottom: 2,
    },
    textFieldContainer: {
      marginBottom: 2,
    },
    textField: {
      width: "100%",
      marginTop: 1,
    },
    buttonGroup: {
      marginTop: 3,
      display: "flex",
      gap: 2,
    },
  };